import { useUserStore } from '@st/user/stores/useUserStore'
import { useCurrenciesStore } from '@st/payments/stores/useCurrenciesStore'
import { useAccountsStore } from '@st/payments/stores/useAccountsStore'
import { useAllowedAssets } from '@st/payments/composables/useAllowedAssets'
import { provideCasinoDeps } from '@st/casino/useDeps'
import MAccountWidget from '@st/payments/components/MAccountWidget/MAccountWidget.vue'
import PageTournamentCard from '@st/tournaments/components/TournamentCard/PageTournamentCard.vue'
import MPageTournamentCard from '@st/tournaments/components/TournamentCard/MPageTournamentCard.vue'
import { usePageTournament } from '@st/tournaments/composables/usePageTournament'
import { useIntercomApi } from '@st/intercom/composables/useIntercomApi'
import { useSettingsStore } from '@st/core/stores/useSettingsStore'

export default defineNuxtPlugin({
  name: 'casinoDeps',
  dependsOn: ['paymentsDeps'],
  setup: () => {
    const userStore = useUserStore()
    const {
      isAuthenticated,
      isReady: isReadyUser,
      userSettings,
    } = storeToRefs(userStore)
    const { updateUserSettings } = userStore

    const currencyStore = useCurrenciesStore()
    const { getCurrencyByCode, getCurrencyById } = currencyStore
    const { appCurrency } = toRefs(currencyStore)

    const accountsStore = useAccountsStore()
    const { activeAccount } = storeToRefs(accountsStore)
    const { isAllAccountsEmpty } = storeToRefs(useAccountsStore())

    const { tournament: casinoTournament } = usePageTournament('casino')

    const { isCurrencyForTMA } = useAllowedAssets()

    const { settings: systemSettings } = storeToRefs(useSettingsStore())

    provideCasinoDeps({
      useIntercomApi,
      isAuthenticated,
      isReady: isReadyUser,
      userCurrencySettings: computed(() => ({
        preferredCurrencyCodeForCasino:
          userSettings.value?.preferredCurrencyCodeForCasino,
        defaultCurrencyIdForCasinoGame:
          systemSettings.value?.defaultCurrencyIdForCasinoGame,
      })),
      isCurrencyForTMA,
      updateUserPreferredCurrencyCodeForCasino: (currencyCode) =>
        updateUserSettings([
          {
            name: 'preferredCurrencyCodeForCasino',
            value: currencyCode,
          },
        ]),
      MAccountWidget,
      activeAccount,
      appCurrency,
      isAllAccountsEmpty,
      casinoTournament,
      PageTournamentCard,
      MPageTournamentCard,
      getCurrencyIdByCode: (code?: string) =>
        code ? getCurrencyByCode(code)?.id : undefined,
      getCurrencyIconById: (id: number) => getCurrencyById(id)?.icon,
      getFiatCurrencyCodeById: (id?: number) =>
        id ? getCurrencyById(id)?.code ?? 'EUR' : 'EUR',
      getCurrencyById,
    })
  },
})
